<template>
  <div class="selection-detail">
    <wxAuth :share="share" ref="child"></wxAuth>
    <div v-if="info">
      <div class="mask" v-if="showMask" @click="setMask(false)">
        <img class="mask-arrow" src="../../assets/images/mask-arrow.png">
        <div class="mask-tip1">点击右上角更多</div>
        <div class="mask-tip2">分享给好友或到朋友圈</div>
      </div>

      <div class="banner">
        <img :src="info.pic" :alt="info.name" />
        <div class="total">{{info.viewCount}}人次已浏览</div>
        <div class="desc">{{info.description}}</div>
        <div class="hr"></div>
        <div class="title">
          <img src="../../assets/images/solution-icon.png"/>
          <span>方案列表</span>
          <small>（{{total}}）</small>
        </div>
      </div>

      <div class="tags" v-if="tagList.length">
        <van-tabs v-model="tagId" color="#2F7BFF" title-active-color="#2F7BFF" :ellipsis="false" @click="toggleTag">
          <van-tab v-for="(item, index) in tagList" :title="item.value" :name="item.id" :key="index" />
        </van-tabs>
      </div>

      <div v-if="!loading && records.length === 0" class="empty">
        <img src="../../assets/images/image_chazhao.png" />
        <p>没有找到相关内容</p>
      </div>

      <div class="list">
        <a v-for="(solution, index) in records" :key="index" class="row" :href="'/solutions/detail/' + solution.solutionId + '.html'">
          <template v-if="solution.suffixes.length > 1">
            <img class="row-icon" src="//image01.homedo.com/Files/Images/cms/www/20190805/5257706577996993572_pic1.png" alt="">
          </template>
          <template v-else>
            <img class="row-icon" :src="solution.suffixes[0] | fileType" alt="">
          </template>
          <div class="row-title">{{solution.solutionName}}</div>
          <div class="row-desc">{{solution.description}}</div>
          <div class="row-info clearfix">
            <div>
              <span><img class="user-icon" src="../../assets/images/user-icon.png"/>{{solution.userName}}</span>
            </div>
            <div>
              <span>{{solution.pageView}}浏览</span>
              <span>{{solution.commentCount}}评论</span>
              <span>{{solution.downloadCount}}下载</span>
            </div>
          </div>
        </a>
      </div>

      <div class="fixed-btn">
        <button @click="setMask(true)">分享</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import wxAuth from '@/components/wxAuth'
import { fetchSelectionDetail, fetchSolutions, fetchTagList } from '@/api/selection/selection'

export default {
  name: 'selection-detail',
  filters: {
    fileType: function (type) {
      if (type === 'ppt' || type === 'pptx') {
        return '//image01.homedo.com/Files/Images/cms/www/20190805/5480198852448354363_pic1.png'
      } else if (type === 'doc' || type === 'docx') {
        return '//image01.homedo.com/Files/Images/cms/www/20190805/5065556020444862923_pic1.png'
      } else if (type === 'pdf') {
        return '//image01.homedo.com/Files/Images/cms/www/20190805/4714196104133310148_pic1.png'
      } else if (type === 'xls' || type === 'xlsx') {
        return '//image01.homedo.com/Files/Images/cms/www/20190805/4882573325853164862_pic1.png'
      } else if (type === 'dwg') {
        return '//image01.homedo.com/Files/Images/cms/www/20190805/4872871580678586404_pic1.png'
      } else {
        return '//image01.homedo.com/Files/Images/cms/www/20190807/4919828709543073167_pic1.png'
      }
    }
  },
  data () {
    return {
      id: '',
      info: null,
      showMask: false,
      page: 1,
      size: 10,
      total: 0,
      records: [],
      share: {
        title: '',
        desc: '',
        imgUrl: '',
        url: window.location.href.split('#')[0]
      },
      tagId: '',
      tagList: [],
      loading: false
    }
  },
  components: {
    wxAuth
  },
  mounted () {
    this.id = this.$route.params.id
    if (this.id) {
      this.fetchDetail()
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    setMask: function (flag) {
      this.showMask = flag
    },

    handleScroll: function (e) {
      if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
        this.loadMore()
      }
    },

    loadMore: function () {
      const maxPage = Math.ceil(this.total / this.size)
      const newPage = this.page + 1
      if (newPage > maxPage) {
        return
      }
      this.fetchSolutions(newPage, this.size, 'push')
    },

    toggleTag: function (name, title) {
      this.tagId = name
      this.page = 1
      this.fetchSolutions(this.page, this.size, 'replace')
    },

    fetchTagList: function () {
      fetchTagList(this.id)
        .then(res => {
          if (res.status === 200 && res.data && res.data.respCode === '0000') {
            const tagList = res.data.data.records || []
            tagList.unshift({id: '', value: '全部'})
            this.tagList = tagList
          }
          this.fetchSolutions(1, this.size, 'replace')
        })
        .catch(err => {
          Toast.clear()
          console.log(err)
        })
    },

    fetchDetail: function () {
      Toast.loading({
        forbidClick: true
      })
      fetchSelectionDetail(this.id)
        .then(res => {
          if (res.status !== 200) {
            Toast.clear()
            return
          }
          if (res.data.respCode !== '0000') {
            Toast.fail(res.data.respDesc)
            Toast.clear()
            return
          }
          this.info = res.data.data || {}
          const title = this.info.name += ' - 方案馆'
          document.title = title
          this.share.title = title
          this.share.desc = this.info.description
          this.share.imgUrl = this.info.pic
          this.$refs.child.wxAuth()
          this.fetchTagList()
        })
        .catch(err => {
          Toast.clear()
          console.log(err)
        })
    },

    fetchSolutions: function (page, size, type) {
      Toast.loading({
        forbidClick: true
      })
      this.loading = true
      fetchSolutions(this.id, {current: page, size, tagId: this.tagId})
        .then(res => {
          this.loading = false
          Toast.clear()
          if (res.status !== 200) {
            return
          }
          if (res.data.respCode !== '0000') {
            Toast.fail(res.data.respDesc)
            return
          }
          this.page = res.data.data.current
          this.total = res.data.data.total
          if (type === 'replace') {
            this.records = res.data.data.records || []
          }
          if (type === 'push') {
            this.records = this.records.concat(res.data.data.records || [])
          }
        })
        .catch(err => {
          this.loading = false
          Toast.clear()
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .van-tab--active {
    color: #2F7BFF!important;
  }

  * {
    box-sizing: border-box;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 990;
    background: rgba(0, 0, 0, 0.8);
    font-size: 13px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 19px;

    &-arrow {
      position: absolute;
      top: 6px;
      right: 19px;
      width: 37px;
      height: 72px;
    }

    &-tip1 {
      position: absolute;
      top: 68px;
      left: 222px;
    }

    &-tip2 {
      position: absolute;
      top: 88px;
      left: 222px;
    }
  }

  .selection-detail {
    background: #fff;
    padding-bottom: 76px;
    min-height: 100vh;

    .banner {
      width: 375px;
      font-size: 0;

      & > img {
        width: 375px;
        height: 118px;
      }

      .total {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 7px;
        height: 18px;
        line-height: 18px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 0 0 0 3px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }

      .desc {
        padding: 16px;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        background: #fff;
      }

      .hr {
        width: 100%;
        height: 12px;
        background: #f7f4f8;
      }

      .title {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        padding: 0 16px;
        background: #fff;

        img {
          width: 16px;
          height: 19px;
          margin-right: 6px;
        }

        small {
          font-size: 14px;
          color: rgba(153, 153, 153, 1);
        }
      }
    }

    .empty {
      padding: 50px 0;
      text-align: center;

      img {
        width: 30%;
        margin-bottom: 10px;
      }
    }

    .tags {
      padding: 0 10px;
    }

    .list {
      background: #fff;
      padding: 0 16px;
      width: 100%;
      overflow-y: scroll;

      .row {
        position: relative;
        padding: 12px 0 12px 75px;
        min-height: 113px;
        display: block;

        &:not(:last-child) {
          border-bottom: 1px solid #EBEBEB;
        }

        &-icon {
          position: absolute;
          top: 15px;
          left: 0;
          width: 65px;
          height: 83px;
        }

        &-title, &-desc {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &-title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 12px;
        }

        &-desc {
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 16px;
          margin-bottom: 18px;
        }

        &-info {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 1.5;
          margin: 0 -6px;

          .user-icon {
            width: 13px;
            margin-top: -5px;
            vertical-align: middle;
            margin-right: 2px;
          }

          span {
            padding: 0 6px;
          }
        }
      }
    }

    .fixed-btn {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 76px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;

      &:before {
        position: absolute;
        top: 0;
        left: 16px;
        width: 342px;
        height: 1px;
        background: #EBEBEB;
        content: "";
      }

      button {
        width: 100%;
        height: 49px;
        border-radius: 24px;
        border: 1px solid #2F7BFF;
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
        background: #2F7BFF;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/selection/detail.vue